import axios from "axios";
import api from "../api";
import { CURRENT_DOMAIN_CRM } from "../../config";
import { Theme } from "../../types/Settings";

export const getThemeSettings = () => axios.get<{ data: Theme }>(`${CURRENT_DOMAIN_CRM}/api/v1/get-style-list`);
export const getThemeMode = () => api.get(`/api/v1/profile/theme`);
export const updateThemeMode = (data) => api.post(`/api/v1/profile/theme`, data);
